import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OpenShift, OpenShiftListFilter, OpenShiftRecipient, OpenShiftRecipients, PagedOpenShifts } from '../types'

interface OpenShiftState {
    loading: boolean
    selectedShiftId: string | null
    recipients: OpenShiftRecipient[]
    shiftsOnPage: OpenShift[]
    totalShiftCount: number
    pageIndex: number
    pageSize: number    
    filter: OpenShiftListFilter | null
    error: Error | string | null
}

const initialState: OpenShiftState = {
    loading: false,
    selectedShiftId: null,
    recipients: [],
    shiftsOnPage: [],
    totalShiftCount: 0,
    pageIndex: 1,
    pageSize: 25,
    filter: null,
    error: null
}

export const openShiftSlice = createSlice({
    name: 'openshift',
    initialState,
    reducers: {
        loading: state => {
            state.loading = true
            state.error = null
        },
        openShiftsFetched: (state, action: PayloadAction<PagedOpenShifts>) => {
            state.loading = false
            state.shiftsOnPage = action.payload.shifts
            state.totalShiftCount = action.payload.totalShiftCount
            state.error = null
        },
        openShiftsFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        recipientsFetchedForOpenShift: (state, action: PayloadAction<OpenShiftRecipients>) => {
            state.loading = false
            state.selectedShiftId = action.payload.openShiftId
            state.recipients = action.payload.openShiftRecipients
        },
        recipientsForOpenShiftFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.selectedShiftId = null
            state.recipients = []
            state.loading = false
            state.error = action.payload
        },
        pageIndexChanged: (state, action: PayloadAction<number>) => {
            state.pageIndex = action.payload
        },
        filterChanged: (state, action: PayloadAction<OpenShiftListFilter>) => {
            state.filter = action.payload
            state.pageIndex = 1
        },
        errorHandled: (state) => {
            state.error = null    
        }
    }
})

export const { 
    loading, 
    openShiftsFetched, 
    openShiftsFetchFailure, 
    recipientsFetchedForOpenShift,
    recipientsForOpenShiftFetchFailure,
    pageIndexChanged, 
    filterChanged, 
    errorHandled 
} = openShiftSlice.actions

export default openShiftSlice.reducer